import type { BlockType } from '@unifyapps/defs/types/block';
import type { DeviceVariantType } from '@unifyapps/defs/types/deviceVariant';
import { invariant } from 'ts-invariant';
import InterfacePageHelper from '../../../helper/InterfacePage';
import type { InterfaceStoreType } from './types';

export const getActiveInterfacePageFromStore = (
  store: Pick<InterfaceStoreType, 'activeInterfacePage'>,
) => {
  return store.activeInterfacePage;
};

export const getActivePage = (getState: () => InterfaceStoreType) => {
  return getState().activeInterfacePage;
};

export const getBlocksFromPage = (
  device: DeviceVariantType,
  store: Pick<InterfaceStoreType, 'activeInterfacePage'>,
): Record<string, BlockType | undefined> => {
  const activeInterfacePage = getActiveInterfacePageFromStore(store);
  invariant(activeInterfacePage, 'activeInterfacePage not found');
  const baseBlocks = InterfacePageHelper.getBaseDeviceBlocks(activeInterfacePage);
  const deviceBlocks = InterfacePageHelper.getDeviceBlocks(activeInterfacePage, device);

  if (!deviceBlocks) {
    return baseBlocks ?? {};
  }

  return {
    ...baseBlocks,
    ...deviceBlocks,
  };
};

export const getInterfaceRecord = (getState: () => InterfaceStoreType) => {
  const state = getState();
  return state.interfaceRecord;
};

export const getPageVariableDetails = (getState: () => InterfaceStoreType, variableId: string) => {
  const activePage = getActivePage(getState);
  return InterfacePageHelper.getPageVariables(activePage)?.[variableId];
};
